import { captureException } from '@sentry/nextjs';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function trackEventImpression(eventId: string): Promise<void> {
  try {
    await bounceApiClient({
      method: 'post',
      url: `/service/events/${eventId}/eventImpressions`
    });
  } catch (error) {
    captureException(error, {
      contexts: { params: { eventId } }
    });
  }
}
